import { CountUp } from 'countup.js';

window.onload = function () {

  var welcomeSection = document.querySelector('.js-welcome');
  var countUpElement = document.querySelector('#countup');
  if(!welcomeSection || !countUpElement)
    return;

  var countUp = new CountUp(
    'countup',                      // id
    countUpElement.dataset.counter, // counter value
    {                               // options
      duration: 5,
      separator: ' ',
    }
  );

  window.addEventListener('scroll', function() {
    var welcomePosition = welcomeSection.getBoundingClientRect();

    if(welcomePosition.top < window.innerHeight && welcomePosition.bottom >= 0) {
      countUp.start();
    }
  });
}
